import gql from 'graphql-tag';

export const MatchFragment = gql`
  fragment MatchFragment on Match {
    id
    studentPaid
    storageDates {
      startDate
      endDate
    }
    items {
      standardBox
      mediumItem
      largeItem
      extraLargeItem
      enormousItem
    }
    listing {
      address
      owner {
        firstName
        lastName
        profilePicture
      }
      price {
        standardBox
        mediumItem
        largeItem
        extraLargeItem
        enormousItem
      }
      location {
        latitude
        longitude
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/CustomerPayment/Queries/MatchFragment.ts